import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import { ExternalAccountSnapshot } from '../../models/Banking';
import {
    BaseReferralTransactionSnapshot,
    ReferralTransactionSnapshot,
} from '../../models/Referral/Statement';
import api, { rawClient } from '../api';

const getWithdrawalAccount = (): Promise<ExternalAccountSnapshot | null> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/referral/external_account`,
    });
};

const createWithdrawal = (
    deduplicationId: string,
    amount: number
): Promise<ReferralTransactionSnapshot> => {
    return api.request({
        method: 'POST',
        url: `${getBackVersion()}/referral/withdrawal`,
        data: decamelizeKeys({
            sessionId: deduplicationId,
            amount,
        }),
    });
};

const getDetails = (id: string): Promise<BaseReferralTransactionSnapshot> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/referral/statement/${id}`,
    });
};

const downloadWithdrawalReceipt = (id: string): Promise<void> => {
    return rawClient.download({
        method: 'GET',
        url: `${getBackVersion()}/referral/statement/${id}/download`,
    });
};

export {
    createWithdrawal,
    downloadWithdrawalReceipt,
    getDetails,
    getWithdrawalAccount,
};
